import GroupsIcon from '@mui/icons-material/Groups';
import React from 'react';
import { palette } from '@/app/theme';

export const RelationshipsIcon = ({
	bgColor = palette.folioTeal,
	width = '24px',
	height = '24px',
	color,
	sx,
	...props
}) => {
	const resolvedColor = color ?? (bgColor === 'transparent' ? 'inherit' : '#fff');
	return (
		<GroupsIcon
			{...props}
			sx={{
				backgroundColor: bgColor,
				width,
				height,
				borderRadius: 2,
				padding: bgColor === 'transparent' ? 0 : '0.15em',
				boxSizing: 'border-box',
				color: resolvedColor,
				...sx,
			}}
		/>
	);
};
